module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-color__editable-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    staticClass: "vue-color__editable-input__input",
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "keydown": _vm.handleKeyDown,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.update]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vue-color__editable-input__label"
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62d8790c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/EditableInput.vue
// module id = 328
// module chunks = 1